import { useEffect, useReducer, useState } from 'react';
import Styles from './Styles.module.css';
import { baseURL, scrollToTop, toaster, user, storage} from '../functions/O3developer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { loadingReducer } from '../reducers/loading-reducer';
import error from '../json/error.json';
import TopBar from '../components/service/TopBar';
import TopCard from '../components/service/TopCard';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import SetPin from '../components/modals/SetPin';


function Spectranet () {
    const navigate = useNavigate();
    
      const fetchPlans = async () => {
        dispatch({type: 'start'});
          await axios.post(baseURL+"/spectranet",  {
        }, {    
          headers:{
              'Authorization':`Bearer ${user().token}`,
              'Content-Type': 'application/json'
          }, 
      }).then((response) => {
          if (response.data.status == "failed" && response.data.message !== "") {
              return toaster("error", response.data.message);
            } else if (response.data.status == "success") {
              // console.log(response.data);
                PINHandler(!response.data.pin);
                  setValue({
                    ...value,
                    plans: response.data.spectranet,
                    });
                    setWallet(response.data.balance);
                    dispatch({type: 'stop'});
              } else {
                return toaster("error", error.loading.excemption);    
              }
    
          }).catch((e) => {
            if (e.response !== undefined) {
              if (e.response.data.code == 401 && e.response.data.message == "Authentication failed") {
                  storage("remove", "data", null, "localStorage");
                  return navigate("/login");
              }
            }
              return toaster("error", error.loading.excemption);
              // return e;
          })
      }
    
    
    /**************************************************************************/
    const [pinModal, setPinModal] = useState(false);
    const [loading, dispatch] = useReducer(loadingReducer, false);
    const [wallet, setWallet] = useState(''); 
    const [value, setValue] = useState({
          phoneNumber: '',
          img: '/dashboard/images/spectranet-banner.jpg',
          imgWidth: '37px',
          imgHeight: '35px',
          plans: [],
          plan_id: '',
          selectedPlan: [],
          amount: '',
          quantity: '',
    });

   
      function planHandler(e) {
        var plan_id = e.target.value;
        if (plan_id !== "") {
          var plan = value.plans.filter((e) => {
              return e.id == plan_id
          });
          setValue({...value, plan_id: plan_id, selectedPlan: plan});
        } else {
          setValue({...value, plan_id: '', selectedPlan: []});
        }
      }
    
      /****************************************************************/

    function proceed(e) {
      e.preventDefault();
      if (value.selectedPlan.length !== 1) return toaster("error", error.validation.emptyPlan);
      if (value.smileNumber == "") return toaster("error", error.validation.emptySmile);
      if (value.phoneNumber == "") return toaster("error", error.validation.emptyPhoneNumber);
      if (value.phoneNumber.length !== 11) return toaster("error", error.validation.invalidPhoneNumber);
      const amount = value.selectedPlan[0].amount;
      if (wallet < amount && wallet !== amount) return toaster("error", error.lowBalance);
      // if (value.selectedPlan[0].amount < wallet || value.selectedPlan[0].amount !== wallet) return toaster("error", error.lowBalance)
//
      let object = {
          "service": "Spectranet",
          "id" : value.selectedPlan[0].id,
          "number": value.phoneNumber,
          "amount": value.selectedPlan[0].amount,
          "plan": value.selectedPlan[0].plan,
      };
      object = JSON.stringify(object);
      if(storage("save", "invoice", object, "sessionStorage")) {
          navigate("/invoice");
      } else {
          return alert(error.whoops);
      }
         
  }
   
  
  const PINHandler = (value) => {
    setPinModal(value);
  }  


  useEffect(() => {
    scrollToTop();
    fetchPlans();
    return () => axios.CancelToken.source();
  },[]);
    
    
    return (
        <div>

    
      <TopBar icon="fas fa-fire"/>
    
        <div className={"page-content " + Styles.page_content}>
    
    
        {/* Top Card */}
        <TopCard wallet={wallet}/>
    
        <div className="card card-clear" style={{ height: "170px" }}></div>
    
    
    
    

    
    <div className={"page-content pb-6 " + Styles.pt_10}>



    <ToastContainer/>

    
    <div className={'card card-full rounded-m pb-1 ' + Styles.data_card_2 } >
    
 
    <div className={"content mb-0 " + Styles.pt_13}>

    <SetPin visibility={pinModal} state={PINHandler} />

    <div hidden={!loading}>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
      {loading ? <SkeletonTheme height={30} width={150}> <Skeleton  count={1}/> </SkeletonTheme> : null }
          <SkeletonTheme height={20} width={220}> <Skeleton count={2}/> </SkeletonTheme>
          </div>
          <SkeletonTheme height={70} width={70}> <Skeleton count={1} circle={true}/> </SkeletonTheme>
      </div>


      <div>
        <SkeletonTheme height={50} width={"100%"}> <Skeleton style={{ marginBottom: "8px" }} count={1}/> </SkeletonTheme> 
        <SkeletonTheme height={50} width={"100%"}> <Skeleton style={{ marginBottom: "8px" }}   count={1}/> </SkeletonTheme>
        <SkeletonTheme height={50} width={"100%"}> <Skeleton style={{ marginBottom: "8px" }}   count={1}/> </SkeletonTheme> 
      </div>

      </div>
    
    <span hidden={loading}>

    <h3><span> Spectranet </span>
    
    <span className="shadow-bg shadow-bg-m shadow-s" style={{float: 'right', width: '55px', height: '55px', padding: '10px', borderRadius: '50%', border: ""}}>
          <img src={ value.img } className="text-center" width={value.imgWidth} height={value.imgHeight} style={{  borderRadius: "50%"  }} />
          </span></h3>
    <p className={ Styles.description_txt }>
    
    Pay for Spectranet Internet Data pin.
    
    </p>
    
    
    <div className="input-style has-borders no-icon mb-4">
        <select id="smile" onChange={planHandler} value={value.plan_id} className="shadow-bg shadow-bg-m shadow-s">
        <option value=""> Please select  </option>
        { value.plans.length !== 0 ? value.plans.map((e, index) => { return <option value={e.id} key={index}> {e.plan} </option> }) : ''}
        </select>
            <span><i className="fa fa-chevron-down"></i></span>
            <i className="fa fa-check disabled valid color-green-dark"></i>
            <i className="fa fa-check disabled invalid color-red-dark"></i>
            <em></em>
      </div>
    




    <div className="input-style has-borders has-icon validate-field mb-4" hidden={false}>
    <i className="fa fa-phone" style={{ color: "#008000" }}></i>
    <input type="number" autoComplete="off" value={value.phoneNumber} onChange={(e) => setValue({...value, phoneNumber: e.target.value})} className="form-control validate-name shadow-bg-m shadow-s" id="number" placeholder="Phone Number" />
    {/* <label htmlFor="form1" className="color-highlight">Phone Number</label> */}
    <i className="fa fa-times disabled invalid color-red-dark"></i>
    <i className="fa fa-check disabled valid color-green-dark"></i>
    <em>(required)</em>
  </div>



  <a href="#" className={"btn btn-3d btn-full btn-m text-uppercase font-800 rounded-sm shadow-bg shadow-bg-m shadow-s " + Styles.proceedBtn } onClick={proceed}>
        Proceed </a>
    
        </span>
    
                </div>
            </div>
            <div className="mb-5"></div>

        </div>
    
    </div>
    
    </div>
    
        );
    }


export default Spectranet